import api from '../config/api';
import { API_ENDPOINTS } from '../config/constants';

export const orderService = {
  // Customer
  createOrder: (orderData) => api.post(API_ENDPOINTS.ORDERS.CREATE, orderData),
  getUserOrders: (params) => api.get(API_ENDPOINTS.ORDERS.MY_ORDERS, { params }),
  getOrderById: (id) => api.get(API_ENDPOINTS.ORDERS.GET(id)),
  cancelOrder: (id, reason) => api.post(API_ENDPOINTS.ORDERS.CANCEL(id), { reason }),

  // Seller
  getSellerOrders: (params) => api.get(API_ENDPOINTS.ORDERS.SELLER_ORDERS, { params }),
  updateFulfillmentStatus: (orderItemId, fulfillment_status) =>
    api.patch(API_ENDPOINTS.ORDERS.UPDATE_FULFILLMENT(orderItemId), { fulfillment_status }),
  getSellerAnalytics: () => api.get(API_ENDPOINTS.ORDERS.SELLER_ANALYTICS),

  // Admin
  getAllOrders: (params) => api.get(API_ENDPOINTS.ADMIN.ALL_ORDERS, { params }),
  updateOrderStatus: (orderId, status) =>
    api.patch(API_ENDPOINTS.ADMIN.UPDATE_ORDER_STATUS(orderId), { status }),

  // Customer dashboard stats
  getDashboardStats: () => api.get(API_ENDPOINTS.USERS.DASHBOARD_STATS),
};
